import React, { Component } from "react"
import Dashboard from '../Dashboard'
import Header from '../../components/Header'
import Footer from '../../components/Footer'
import { Link, Redirect } from 'react-router-dom'
import { connect } from 'react-redux'
import { fetchReauthenticateMembersAction } from  '../../actions/Authentification/Reauthenticate'

class Reglages extends Component {
  componentDidMount() {
    document.title = `Dashboard Membre | Réglages`
    const { getReauthenticate } = this.props
    getReauthenticate()
  }
  render() {
    const { match, reauthenticateMembers } = this.props

    return (
      <div>
        <Header userIsSuccessLogin={reauthenticateMembers.isSuccess} />
          {reauthenticateMembers.isLoading
            ?
              <div className="aps-spinner-container-loading">
                <div className="uk-spinner">
                  <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 30 30" ratio="1">
                     <circle fill="none" stroke="#AEC340" cx="15" cy="15" r="14"></circle>
                  </svg>
                </div>
                <div className="aps-section-register-desc">chargement en cours</div>
              </div>
            :
              <Dashboard match={match}>
                <div className="aps-dashboard-body-second-content">
                  <div className="aps-dashboard-body-container-title">
                    <p className="uk-text-center aps-dashboard-body-title">
                      Réglages de votre compte
                    </p>
                  </div>
                  <div className="aps-dashboard-body-container-reglages-desc">
                    <hr className="aps-btn-pre-header-divider" />
                  </div>
                  {/*Section informations User*/}
                  <div className="aps-dashboard-body-container-reglages-desc aps-dashboard-body-container-reglages-show-web">
                    <div className="aps-dashboard-reglages-user-data">
                      <span className="aps-dashboard-reglages-user-data-attribut">Nom :</span>
                      <span className="aps-dashboard-reglages-user-data-value">
                        {reauthenticateMembers.userData.firstname && reauthenticateMembers.userData.firstname}
                      </span>
                      <span className="" style={{float: "right"}}>
                        <Link className="uk-button aps-btn-silver" to="/reglages-user-data">Modifier les informations</Link>
                      </span>
                    </div>
                    <div className="aps-dashboard-reglages-user-data-second aps-dashboard-reglages-padding-bottom">
                      <span className="aps-dashboard-reglages-user-data-attribut">Prénom :</span>
                      <span className="aps-dashboard-reglages-user-data-value" style={{paddingLeft: "20px"}}>
                        {reauthenticateMembers.userData.lastname && reauthenticateMembers.userData.lastname}
                      </span>
                    </div>
                  </div>
                  <div style={{display: "none"}} className="aps-dashboard-body-container-reglages-desc aps-dashboard-body-container-reglages-show-mobile">
                    <div className="aps-dashboard-reglages-user-data">
                      <div>
                        <span className="aps-dashboard-reglages-user-data-attribut">Nom :</span>
                        <span className="aps-dashboard-reglages-user-data-value">
                        {reauthenticateMembers.userData.firstname && reauthenticateMembers.userData.firstname}
                        </span>
                      </div>
                    </div>
                    <div className="aps-dashboard-reglages-user-data-second aps-dashboard-reglages-padding-bottom">
                      <div>
                        <span className="aps-dashboard-reglages-user-data-attribut">Prénom :</span>
                        <span className="aps-dashboard-reglages-user-data-value" style={{paddingLeft: "20px"}}>
                          {reauthenticateMembers.userData.lastname && reauthenticateMembers.userData.lastname}
                        </span>
                      </div>
                      <div>
                        <span className="" style={{float: "right", paddingTop: "20px"}}>
                          <Link className="uk-button aps-btn-silver" to="/reglages-user-data">Modifier les informations</Link>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="aps-dashboard-body-container-reglages-desc">
                    <hr className="aps-btn-pre-header-divider" />
                  </div>
                  {/*Section lost password*/}
                  <div className="aps-dashboard-body-container-reglages-desc aps-dashboard-body-container-reglages-show-web">
                    <div className="aps-dashboard-reglages-user-data">
                      <span className="aps-dashboard-reglages-user-data-attribut">Mot de passe : </span>
                      <span className="" style={{float: "right"}}>
                        <Link className="uk-button aps-btn-silver" to="/reglages-user-password">Modifier le mot de passe</Link>
                      </span>
                    </div>
                    <div className="aps-dashboard-reglages-user-data">
                      <span className="aps-dashboard-reglages-text-desc">Définissez un mot de passe unique pour protéger votre compte </span>
                    </div>
                  </div>
                  <div style={{display: "none"}} className="aps-dashboard-body-container-reglages-desc aps-dashboard-body-container-reglages-show-mobile">
                    <div className="aps-dashboard-reglages-user-data">
                      <div>
                        <span className="aps-dashboard-reglages-user-data-attribut">Mot de passe : </span>
                      </div>
                      <div>
                        <span className="" style={{float: "right"}}>
                          <Link className="uk-button aps-btn-silver" to="/reglages-user-password">Modifier le mot de passe</Link>
                        </span>
                      </div>
                    </div>
                    <div className="aps-dashboard-reglages-user-data" style={{paddingTop: "43px"}}>
                      <span className="aps-dashboard-reglages-text-desc">Définissez un mot de passe unique pour protéger votre compte </span>
                    </div>
                  </div>
                  <div className="aps-dashboard-body-container-reglages-desc">
                    <hr className="aps-btn-pre-header-divider" />
                  </div>
                  {reauthenticateMembers.isError &&
                    <div>
                      <Redirect to='/connexion' push/>
                    </div>
                  }
                </div>
              </Dashboard>
          }
      <Footer />
    </div>
    )
  }
}
const mapStateToProps = ({ reauthenticateMembers }) => {
  return {
    reauthenticateMembers,
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    getReauthenticate: () => dispatch(fetchReauthenticateMembersAction()),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Reglages)



// WEBPACK FOOTER //
// ./src/containers/Reglages/index.js